<template>
  <UiSectionWrapper
    title="Aktifkan WhatsApp Follow-up. Ubah Setiap Kiriman Jadi Kesempatan Bangun Loyalitas!"
    sub-title="Whatsapp Follow-up"
    description="Buat pelanggan merasa diperhatikan tanpa repot manual. Notifikasi otomatis, komunikasi lebih hangat, bisnis makin efisien."
    hero-image="/images/wafu-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Aktifkan Sekarang"
    :button-link="
      $utm.utmUrl('/login', {
        redirectTo: '/settings/whatsapp-fu'
      })
    "
  />
</template>
